import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import { Icon } from "@vds/icons";
import { Body, Title } from "@vds/typography";
import { UnorderedList, ListItem } from "@vds/lists";
import {
  BILLING_ACCOUNT_MODAL_TITLE,
  BILLING_ACCOUNT_MODAL_LABEL,
  BILLING_ACCOUNT_MODAL_NO_USERS,
  BILLING_ACCOUNT_MODAL_CLOSE_BUTTON,
} from "../../global/constants/userDetailsConstants";

const UsersOnBillingAccountModal = ({ opened, accountId, users, onClose }) => {
  return (
    <Modal
      opened={opened}
      hideCloseButton={false}
      className="modal-confirmation"
      disableOutsideClick={true}
      onClose={onClose}
    >
      <Title size="large" bold primitive="h2" viewport="desktop">
        {BILLING_ACCOUNT_MODAL_TITLE}
      </Title>
      <ModalBody>
        <Body size="medium" viewport="desktop" primitive="span">
          <p className="modal-confirmation-text">
            {BILLING_ACCOUNT_MODAL_LABEL} <strong>{accountId}</strong>
          </p>
          <div className="modal-scrollable-content">
            {users?.length > 0 ? (
              <UnorderedList>
                {users.map((user) => (
                  <ListItem key={user?.id} size="bodyLarge">
                    {user?.firstname} {user?.lastname}
                  </ListItem>
                ))}
              </UnorderedList>
            ) : (
              <p>{BILLING_ACCOUNT_MODAL_NO_USERS}</p>
            )}
          </div>
        </Body>
      </ModalBody>
      <ModalFooter
        buttonData={{
          primary: {
            "data-testid": "userdetails_closeBillingAccountUsersModalButton",
            className: "modal-button-full-width",
            children: BILLING_ACCOUNT_MODAL_CLOSE_BUTTON,
            onClick: onClose,
          },
        }}
      />
    </Modal>
  );
};

export default UsersOnBillingAccountModal;
